import { render, staticRenderFns } from "./OrdersLayout.vue?vue&type=template&id=fa2b72e8"
import script from "./OrdersLayout.vue?vue&type=script&lang=js"
export * from "./OrdersLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports